module.exports = __webpack_public_path__ + "img/reco_parrainage.be9ffdf7.jpg";